import { render } from "./SearchProjectsResults.vue?vue&type=template&id=77e98b37"
import script from "./SearchProjectsResults.vue?vue&type=script&lang=js"
export * from "./SearchProjectsResults.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__